"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkWebhook = exports.isWebhook = void 0;
const Check_1 = require("../check/Check");
function isWebhook(object) {
    return checkWebhook(object).fulfilled;
}
exports.isWebhook = isWebhook;
function checkWebhook(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, Check_1.check)(object, (0, Check_1.hasString)("id"), (0, Check_1.hasString)("companyId"), (0, Check_1.hasString)("event"), (0, Check_1.hasString)("url"), (0, Check_1.hasMap)("headers", (0, Check_1.isString)()).optional()).withOptions(options).explain();
}
exports.checkWebhook = checkWebhook;
//# sourceMappingURL=Webhook.js.map